/* eslint-disable react-hooks/exhaustive-deps */

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Switch,
  Typography,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { observer } from "mobx-react";
import Controls from "../atoms/Controls";
import { getKvnrError } from "../utils/kvnrValidator";
import EditTable, { validateFrequency, validateTherapy } from "../molecules/Editable";
import Form, { rxuseForm } from "./PatientDataEntryForm/Form";
import { format } from "date-fns";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DoctorContext } from "../stores/Doctor/doctor.provider";
import { useIcdCodes, useMasterTables, resolveTarifGroupForRxType } from "../stores/MasterTables";
import useStore from "../helpers/useStore";
import AddIcon from "@mui/icons-material/Add";
import { NoteDto, PatientDto } from "../api-client";
import { UserContext } from "../stores/User/User.provider";
import { useUserAccounts } from "../stores/User/User.hooks";
import { Delete } from "@mui/icons-material";
import { RxStoreContext } from "../stores/Rx/rx.provider";
import React from "react";
import notificationStore from "../stores/Notification/notificationStore";
import { confirmDoctorClinicJoin } from "./DoctorManagement/confirmDoctorClinicJoin";
import { confirmDoctorClinicMismatch } from "./DoctorManagement/confirmDoctorClinicMismatch";
import Verordnung13 from "./PatientOverview/RxInfo/RxForms/Kasse/Verordnung13";
import ValidationCard, { formType } from "../molecules/ValidationCard";
import WarningDialog from "../atoms/WarningDialog";
import FlatCard from "../atoms/FlatCard";
import VerordnungDialog from "./PatientOverview/RxInfo/RxForms/Kasse/VerordnungDialog";
import { ClinicForModal, Doctor } from "./DoctorManagement/DoctorTabContent/doctor-client-types";
import { useCopyToContinuous, useSaveRxs } from "../stores/Rx/rx.mutations";
import { useRx } from "../stores/Rx/rx.queries";
import { usePatient } from "../stores/Patients/patient.queries";
import moment from "moment";
import SimpleDocumentViewer from "./Documents/SimpleDocumentViewer";
import type { RowData } from "../molecules/Editable";
import { usePrescribedTherapyOptions } from "../stores/MasterTables/masterTables.queries";

interface RxProps {
  isEditing?: boolean;
  selectedRxId?: string;
  patientId?: number;
  readOnlyView?: boolean;
  openRx?: boolean;
  onCloseRx?: any;
  useDialog?: boolean;
}
interface DiagnoseGroup {
  a: string;
  b: string;
  c: string;
  d: string;
}

const RxPage: React.FC<RxProps> = observer(
  ({ isEditing, selectedRxId, patientId, readOnlyView, openRx, onCloseRx, useDialog }) => {
    // Fetch RX data using the rxId from store
    const { data: selectedRow, isLoading: isRxLoading, error: rxError } = useRx(selectedRxId!);
    // Prescribed TERMS — the catalog level a prescription names (MD-232).
    const { data: termOptions = [] } = usePrescribedTherapyOptions();

    // Get patient data from store
    const { data: patientValues } = usePatient(patientId!);
    const { mutate: patientSaveRxs } = useSaveRxs();
    const [therapytableData, settherapyTableData] = useState([]);
    const [selectedLANR, setSelectedLANR] = useState<string | null>(null);
    const [selectedBSNR, setSelectedBSNR] = useState<string | null>(null);
    const [selectedChipCard, setSelectedChipCard] = useState<string | null>(null);
    const [selectedPayer, setSelectedPayer] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const DoctorStore = useStore(DoctorContext);
    const { getClinicById, getDoctorById, createDoctorWithClinic } = DoctorStore;
    // React Query master tables (replaces MasterTablesContext)
    const { data: masterTablesData } = useMasterTables();
    const safeMasterTablesData = masterTablesData || [];
    const [currentICD, setCurrentICD] = useState(null)
    const { data: icdObject } = useIcdCodes(currentICD,false); // disabled initially
  
    // const NotesStore = useStore(NotesContext);
    // const { getRxNotes, postNotes ,updateNoteById} = NotesStore;
    const [rxNotes, setRxNotes] = useState<NoteDto[]>([]);
    const UserStore = useStore(UserContext);
    const RxStore = useStore(RxStoreContext);
    const { user } = UserStore;
    const accounts = useUserAccounts();
    // const [doctorOptions, setDoctorOptions] = useState([]);
    const [fetchedData, setFetchedData] = useState(null);
    const [showWarning, setShowWarning] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDiagnoseGroup, setSelectedDiagnoseGroup] = useState<DiagnoseGroup | null>(null);

    const [isAddEditDialogOpen, setAddEditDialogOpen] = useState(false);
    const [menu, setMenu] = useState<null | HTMLElement>(null);
    const [showGenericView, setShowGenericView] = useState(false);
    const [unsavedChangesWarning, setShowunsavedChangesWarning] = useState(false); //To open dialog
    const [unsavedChanges, setUnsavedChanges] = useState(false); // Flag to track unsaved changes
    // const [isDoctorNumberDisabled, setIsDoctorNumberDisabled] = useState(true);
    const [doesClinicExist, setDoesClinicExist] = useState(false);
    const [isClinicModalOpen, setIsClinicModalOpen] = useState(false);
    const [currentClinicId, setCurrentClinicId] = useState("");
    const [isDocumentViewerOpen, setIsDocumentViewerOpen] = useState(false);
    const [creationResponse, setCreationResponse] = useState({
      id: "",
      clinics: [],
      contactInfo: {},
      doctorId: "",
      clinicId: "",
    });
    const [currentDoctorId, setCurrentDoctorId] = useState("");
    const [doesDoctorExist, setDoesDoctorExist] = useState(false);
    const [currentClinic, setCurrentClinic] = useState<ClinicForModal | undefined>(
      selectedRow?.clinic as any
    );
    const [showClinicData, setShowClinicData] = useState(false);
    const [currentDoctor, setCurrentDoctor] = useState<Doctor | ClinicForModal>();
    const { mutate: copyToContinous } = useCopyToContinuous();
    // const handleToggle = () => {
    //   setShowGenericView(!showGenericView);
    // };
    useEffect(() => {
      const rxType = patientValues?.rxs?.find((rx: any) => rx.id === selectedRxId);
      const therapyRxs = rxType?.therapyRxs;
      // console.log("Frequenciesujjj:", rxType);
      const frequencies = new Set();
      therapyRxs?.forEach((therapy: any) => {
        // console.log("Frequenciesujjj:nnn", therapy);
        const frequencyId = therapy?.frequency?.id || therapy.frequency; // Ensure frequency is not null or undefined
        if (frequencyId) {
          frequencies.add(frequencyId);
        }
      });

      // console.log("Frequencies:", frequencies);

      const isKasse = rxType?.rxtype?.toString() === "Kasse" || rxType?.rxtype?.id === "Kasse";
      const isSingleFrequency = frequencies.size === 1 || frequencies.size === 0;

      // Default to generic view if "Kasse" and frequency size is 1
      if (isKasse && isSingleFrequency) {
        setShowGenericView(true);
      } else {
        setShowGenericView(false); // Default to form view otherwise
      }

      // Show error if switching to generic view when conditions are not met
      if (!showGenericView && isKasse && !isSingleFrequency) {
        // notificationStore.showMessage("Therapiefrequenzwerte sind nicht eindeutig für die Generische Ansicht.", "error");
      }
    }, [selectedRow, patientValues]);

    const handleToggle = () => {
      if (unsavedChanges) {
        setShowunsavedChangesWarning(true);
      } else {
        const rxType = patientValues?.rxs?.find((rx: any) => rx.rxNumber === selectedRow?.rxNumber);
        const therapyRxs = rxType?.therapyRxs;

        const frequencies = new Set();
        therapyRxs?.forEach((therapy: any) => {
          const frequencyId = therapy?.frequency?.id || therapy?.frequency; // Ensure frequency is not null or undefined
          if (frequencyId) {
            frequencies.add(frequencyId);
          }
        });

        const isSingleFrequency = frequencies.size === 1;

        // Check if switching to generic view is allowed
        if (!isSingleFrequency && !showGenericView) {
          notificationStore.showMessage(
            "Therapiefrequenzwerte sind nicht eindeutig für die Generische Ansicht.",
            "error"
          );
          return;
        }

        setShowGenericView(!showGenericView);
      }
    };

    // Separate handler for the "More" button click
    const handleMoreButtonClick = (event: React.MouseEvent<HTMLElement>) => {
      setMenu(event.currentTarget);
      // Stop event propagation to prevent it from reaching the row click handler
      event.stopPropagation();
    };

    const handleMenuClose = () => {
      setMenu(null);
    };
    const handleCreateVirtualPrescription = async () => {
      // try {
      //   // Make an API call to create a virtual prescription for the selected row
      //   const response = await copyToContinous(selectedRow.id);
      //   const updatedFormData = {
      //     ...patientValues,
      //     rxs: [...patientValues.rxs, response],
      //   };
      //   // setMasterPatientData(updatedFormData);
      //   // console.log("updateddgghhh", updatedFormData, updatedRxValues);
      //   handleData(updatedFormData);
      //   // After the API call is successful, fetch updated data and refresh the component
      // } catch (error) {
      //   // Handle any errors that may occur during the API call
      //   console.error("Error creating virtual prescription:", error);
      //   // You can also display an error message to the user.
      // }
    };

    // const handleOpenAddEditDialog = () => {
    //   setAddEditDialogOpen(true);
    // };
    const handleOpenAddEditDialog = (lanr: string | null, bsnr: string | null) => {
      setSelectedLANR(lanr);
      setSelectedBSNR(bsnr);
      setAddEditDialogOpen(true);
    };

    const handleCloseWarning = () => {
      setShowWarning(false);
    };

    const handleCloseAddEditDialog = (data: any) => {
      // Handle doctor data, LANR, and BSNR passed back from DoctorDialog
      setAddEditDialogOpen(false);

      // Here you can perform further actions with the received data
      if (data && "number" in data) {
        const { number, clinicNumber, contactInfo, id } = data;

        // Update states or perform other operations based on the received data
        setSelectedLANR(number);
        setSelectedBSNR(clinicNumber);
        setSelectedDoctor(contactInfo?.lastName);
        setFormValues((prevFormValues: any) => ({
          ...prevFormValues,
          doctorNumber: number,
          practiceNumber: clinicNumber,
        }));

        // For example, you can update doctor form values if needed
        // setDoctorFormValues(doctorData);
      }
    };

    // const fetchDoctorOptions = async () => {
    //   try {
    //     const response = await getAllDoctors();
    //     console.log("Resppnse", response);
    //     setDoctorOptions(response);
    //   } catch (error) {
    //     console.error("Error fetching doctor options:", error);
    //   }
    // };

    // const handleDoctorChange = (selectedValue) => {
    //   setSelectedDoctor(selectedValue);
    //   fetchData(selectedValue);
    // };
    const handleDeleteTherapy = (therapyId: string) => {
      // Filter out the therapy that matches the given ID
      const updatedTherapies = formValues.therapyRxs.filter(
        (therapy: any) => therapy.id !== therapyId
      );

      const updatedTableData: any = updatedTherapies?.map((therapy: any) => ({
        id: therapy.id,
        date: selectedRow?.date,
        rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
        therapy: therapy?.therapy?.abbreviation || therapy.therapy,
        amount: therapy.amount,
        frequency: therapy.frequency?.text || therapy.frequency,
        unitsPerDay: therapy.unitsPerDay,
        isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
        rxSeries: therapy.rxSeries,
      }));
      settherapyTableData(updatedTableData);

      // Update formData state with new therapy list
      setFormValues({
        ...formValues,
        therapyRxs: updatedTherapies,
      });
    };

    const treatmentColumns: any[] = [
      // {
      //   field: "therapy",
      //   headerName: "Heilmittel",
      //   // width: 150,
      //   editable: true,
      // },
      {
        field: "Actions",
        headerName: "Actions",
        sortable: false,
        renderCell: (params: any) => (
          <IconButton size="small" onClick={() => handleDeleteTherapy(params.row.id)}>
            <Delete fontSize="small" />
          </IconButton>
        ),
      },

      { field: "amount", headerName: "Menge", editable: true },

      {
        field: "frequency",
        headerName: "Frequency",
        // width: 150,
        editable: true,
      },
    ];
    const rxType = safeMasterTablesData
      .filter((obj: any) => "rxType" in obj) // Filter objects that have the insuranceStatus property
      .map((obj: any) => obj.rxType);
    const diagnoseGroups = safeMasterTablesData
      .filter((obj: any) => "diagnosisGroups" in obj)
      .map((obj: any) => obj.diagnosisGroups);
    const insurer = safeMasterTablesData
      .filter((obj: any) => "insurer" in obj)
      .map((obj: any) => obj.insurer);

    const account = safeMasterTablesData
      .filter((obj: any) => "account" in obj)
      .map((obj: any) => obj.account);
    // const doctors = masterData
    // .filter((obj: any) => "doctor" in obj)
    // .map((obj: any) => obj.doctor);
    const selectedInsurer = insurer[0]
      ? insurer[0].find(
          (insurer: any) => insurer.id === (patientValues?.payer || patientValues?.payer?.id)
        )
      : "";
    const initialFormValues = {
      // receiptId
      //  PatientId
      rxtype: "",
      firstName: patientValues?.firstName,
      lastName: patientValues?.lastName,
      dob: patientValues?.dob,
      accountId: "",
      employee: "",
      chipcard: "",
      tarifGroupId: patientValues?.tarifGroupId,
      // symptomCode: "",
      a: false,
      b: false,
      c: false,
      d: false,
      symptoms: "",
      Receiptpayer: patientValues?.payer,
      insuranceStatus: patientValues?.status,
      insureeNumber: patientValues?.insuranceNo,
      signatureStatus: "",
      isPerpetual: false,
      unvirtualize: false,
      isCopaymentExempted: false,
      isAccident: false,
      isBVG: false,
      status: "",
      hasIndividualSymptoms: false,
      hygiene: false,
      isAutoAddReport: false,
      urgent: false,
      // homeVisit: false,
      therapyReport: false,
      // isHomeVisitFree: false,
      date: "",
      icdCodeEntries: [{ userText: "" }, { userText: "" }],
      practiceNumber: "",
      // number:"",
      doctorNumber: "",
      doctorId: "",
      clinicId: "",
      additionalNotes: "",
      diagnosegroup: null,
      diagnosisText: "",
      isPerpetualApproved: false,
      therapyRxs: [],
      creationDate: "",
      isHomeVisit: selectedRow?.isHomeVisit ?? null,
      problematic: false,
      changeRequested: false,
      clinic: {} as any,
    };

    const insurerName = selectedInsurer?.name ?? "";

    const [formValues, setFormValues] = useState(initialFormValues);

    const [isHausbesuchSelected, setHausbesuchSelected] = useState<boolean | null>(
      formValues.isHomeVisit
    );
    const handleCheckboxChange = (event: any) => {
      const selectedValue = event.target.value; // "yes" or "no"

      if (selectedValue === "yes") {
        setHausbesuchSelected(true);
        // Set isHomeVisit to true if "yes" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: true,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else if (selectedValue === "no") {
        setHausbesuchSelected(false);
        // Set isHomeVisit to false if "no" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: false,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else {
        setHausbesuchSelected(null); // Set null if neither is selected
        // Set isHomeVisit to null if neither checkbox is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: null,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      }
    };
    const [icdCodeEntries, setIcdCodeEntries] = useState(initialFormValues.icdCodeEntries);
    const rxvalidate = (fieldValues = formValues) => {
      let temp: any = { ...rxerrors };
      // if ("rxtype" in fieldValues)
      //   temp.rxtype = fieldValues.rxtype ? "" : "Pflichtfeld";
      // Validate chipcard (if chipcard exists in fieldValues)
      if ("chipcard" in fieldValues) {
        const chipCardValue = fieldValues.chipcard;
        if (chipCardValue && !insurer[0]?.some((option: any) => option.ik === chipCardValue)) {
          temp.chipcard = "Ungültige Chipkartennummer";
        } else {
          temp.chipcard = ""; // Clear error if valid
        }
      }
      if ("accountId" in fieldValues) temp.accountId = fieldValues.accountId ? "" : "Pflichtfeld";
      // if ("chipcard" in fieldValues)
      //   temp.chipcard = fieldValues.chipcard ? "" : "Pflichtfeld";
      // if ("Receiptpayer" in fieldValues)
      //   temp.Receiptpayer = fieldValues.Receiptpayer ? "" : "Pflichtfeld";
      if ("tarifGroupId" in fieldValues)
        temp.tarifGroupId = fieldValues.tarifGroupId ? "" : "Pflichtfeld";
      // if ("practiceNumber" in fieldValues)
      //   temp.practiceNumber = fieldValues.practiceNumber ? "" : "Pflichtfeld";
      // if ("doctorNumber" in fieldValues)
      //   temp.doctorNumber = fieldValues.doctorNumber ? "" : "Pflichtfeld";
      // if ("doctorId" in fieldValues)
      //   temp.doctorId = fieldValues.doctorId ? "" : "Pflichtfeld";

      // if ('email' in fieldValues)
      //     temp.email = (/$^|.+@.+..+/).test(fieldValues.email) ? "" : "Email is not valid."

      rxsetErrors({
        ...temp,
      });

      if (fieldValues == formValues) return Object.values(temp).every((x) => x == "");
    };
    const { rxerrors, rxsetErrors } = rxuseForm(initialFormValues, true, rxvalidate);

    // Initialize with two input boxes
    useEffect(() => {
      const fetchData = async () => {
        if (isEditing && selectedRow?.rxNumber) {
          try {
            let rxs: [] = [];
            let updatedFormValues = { ...formValues };
            if (selectedRxId) {
              const rx: any = selectedRow;
              // TherapyRxs for table
              const rxs = (rx?.therapyRxs || []).flatMap((therapy: any) => ({
                id: therapy.id,
                date: rx?.date,
                // MD-232: carried through the round trip — the only field
                // naming the term on save (`toTherapyRxWriteDto` sends
                // rawText/prescribedTherapyId, never `therapy`).
                rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
                therapy: therapy?.therapy?.abbreviation || therapy.therapy,
                amount: therapy.amount,
                frequency: therapy.frequency?.text || therapy.frequency,
                unitsPerDay: therapy.unitsPerDay,
                isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
                rxSeries: therapy.rxSeries,
              }));

              let icdCodeEntries;

              if (rx?.icdCodeEntries && rx?.icdCodeEntries.length > 0) {
                if (rx.icdCodeEntries.length === 1) {
                  icdCodeEntries = [...rx.icdCodeEntries, { userText: "" }];
                } else {
                  icdCodeEntries = rx.icdCodeEntries;
                }
              } else {
                icdCodeEntries = [{ userText: "" }, { userText: "" }];
              }

              const formattedValues = {
                ...rx,
                firstName: patientValues?.firstName,
                lastName: patientValues?.lastName,
                dob: moment(patientValues?.dob).format("YYYY-MM-DD") || "",
                insuranceStatus: readOnlyView
                  ? rx?.insuranceStatus
                  : rx?.insuranceStatus || patientValues?.status,
                insureeNumber: rx?.insureeNumber || patientValues?.insuranceNo,
                Receiptpayer:
                  insurer[0].find((option: any) => option.id === rx?.Receiptpayer)?.name ||
                  rx?.payer?.name,
                chipcard: rx?.chipcard || rx?.payer?.ik,
                diagnosegroup:
                  diagnoseGroups[0].find((option: any) => option.id === rx?.diagnosegroup)?.code ||
                  rx?.diagnosisGroup?.code,
                rxtype:
                  rxType[0].find((option: any) => option.id === rx?.rxtype)?.text ||
                  rx?.rxtype?.text,
                accountId:
                  account[0].find((option: any) => option.id === rx?.accountId)?.name ||
                  rx?.account?.name,
                icdCodeEntries: icdCodeEntries,
                // Map new API field names to form's internal keys
                doctorNumber: rx?.LANR || "",
                practiceNumber: rx?.BSNR || "",
                doctorId: rx?.doctorId || rx?.doctorNumber || "",
                clinicId: rx?.clinicId || rx?.practiceNumber || "",
              };

              updatedFormValues = {
                ...formValues,
                ...formattedValues,
                therapyRxs: rxs,
              };
              // console.log("GZTUUU", formValues, updatedFormValues);

              // handleData({...patientValues,rxs:filteredRxs})

              setFormValues(updatedFormValues);
              settherapyTableData(rxs);
              // console.log("RDFF", rxs, formValues);
            }
          } catch (error) {
            // console.log("error", error);
          }
          // };

          // fetchData();
          // dummyApiFetch().then((data) => {
          //   setValues(data);
          // });
        }
        // Make API request to fetch patient data based on patient ID or any other identifier
        else {
          const rx: any = selectedRow;
          const therapyRxs: any = (rx?.therapyRxs || []).map((therapy: any) => ({
            id: therapy.id || uuidv4(),
            date: rx?.date,
            // MD-232: carried through the round trip — see above.
            rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
            therapy: therapy.therapy,
            amount: therapy.amount,
            frequency: therapy.frequency || null,
            unitsPerDay: therapy.unitsPerDay,
            isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
            rxSeries: therapy.rxSeries,
          }));

          settherapyTableData(therapyRxs);
          const updatedRx = {
            ...formValues,
            accountId:
              account[0].find((option: any) => option.id === rx?.accountId)?.name || rx?.accountId,
            diagnosegroup:
              diagnoseGroups[0].find((option: any) => option.id === rx?.diagnosegroup)?.code ||
              rx?.diagnosisGroup?.code,
            rxtype:
              rxType[0].find((option: any) => option.id === rx?.rxtype)?.text || rx?.rxtype?.text,
            Receiptpayer:
              insurer[0].find((option: any) => option.id === rx?.Receiptpayer)?.name || insurerName,
            // icdCodeEntries:filteredRxs[0].icdCodeEntries,
            therapyRxs: therapyRxs,
          };

          // // // const updatedFormValues = { ...formValues, rxs: updatedRxs };
          setFormValues(updatedRx);
        }
      };
      fetchData();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditing, patientValues?.rxs, selectedRow, showGenericView]);

    useEffect(() => {
      setIcdCodeEntries(formValues.icdCodeEntries);
      // console.log("Updated icdCodeEntries:", formValues.icdCodeEntries);
    }, [formValues]);

    // console.log("Fteched", formValues);

    const handleInputChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      index?: any,
      icdEntryId?: string
    ) => {
      // console.log("LUUZZ", event);
      setUnsavedChanges(true);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { name, value, checked, type, id } = event.target;

      const inputValue = type === "checkbox" ? checked : value;
      if (name === "practiceNumber") {
        if (value.length > 9) return;
      }

      if (name === "doctorNumber") {
        if (value.length > 9) return;
        // Only update the field, do not clear doctor info here!
        setFormValues((prevValues: any) => ({
          ...prevValues,
          doctorNumber: value,
        }));
        return;
      }
      // console.log("input", inputValue, checked);
      // console.log("Event:", event.target.name, event.target.value, index);
      if (name === "date" && formValues.isPerpetual && value) {
        setFormValues((prevValues: any) => ({
          ...prevValues,
          unvirtualize: true,
        }));
      }
      // if (name.startsWith("icdCodeEntries")) {
      //   setFormValues((prevValues: any) => ({
      //     ...prevValues,
      //     icdCodeEntries: prevValues.icdCodeEntries.map(
      //       (icdEntry: any, i: number) => {
      //         return i === index
      //           ? { id: icdEntryId || undefined, userText: inputValue }
      //           : { id: icdEntry?.id, userText: icdEntry?.userText || "" };
      //       }
      //     ),
      //   }));
      // }
      // Check if the input is for icdCodeEntries

      if (name.startsWith("icdCodeEntries")) {
        const inputElement = document.querySelector(`[name="${name}"]`) as
          | HTMLInputElement
          | HTMLTextAreaElement;
        const cursorPosition = inputElement?.selectionStart || 0;
        let updatedValue = value;
        let newCursorPosition = cursorPosition; // Initialize new cursor position

        // Check if the length is at least 4 and if a period needs to be inserted
        if (value.length >= 4) {
          // Check if the period already exists at the correct position
          if (!value.includes(".")) {
            // Insert a period after the third character if it's not already there
            updatedValue = value.slice(0, 3) + "." + value.slice(3);

            // Adjust cursor position if a period was inserted before the original cursor position
            if (cursorPosition > 3) {
              newCursorPosition = cursorPosition + 1; // Move cursor one position forward
            }
          }
        }

        // Update the form values with the correctly formatted value
        setFormValues((prevValues: any) => ({
          ...prevValues,
          icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
            return i === index
              ? { id: icdEntryId || undefined, userText: updatedValue }
              : { id: icdEntry?.id, userText: icdEntry?.userText || "" };
          }),
        }));

        // Restore cursor position after the update
        setTimeout(() => {
          if (inputElement) {
            inputElement.selectionStart = inputElement.selectionEnd = newCursorPosition;
          }
        }, 0);
      }

      // Leitsymptomatik: the a/b/c/d codes and the patientenindividuelle flag are
      // independent — a Verordnung can require both, so neither clears the other.
      // Update form fields based on their names
      setFormValues((prevValues: any) => ({
        ...prevValues,
        [name]: id ? id : inputValue,
      }));

      // setFormValues((prevValues: any) => ({
      //   ...prevValues,
      //   rxs: prevValues.rxs.map((rx: any) => ({
      //     ...rx,
      //     [name]: id ? id : inputValue,
      //   })),
      // }));
      // if (name === "doctorNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions?.find(
      //     (doctor: any) => doctor.number === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   console.log("UZZHHHH", selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       practiceNumber: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedBSNR(selectedDoctor.clinicNumber);
      //   }
      // }
      // if (name === "practiceNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.clinicNumber === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       doctorNumber: selectedDoctor.number,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      // }
      if (name === "Receiptpayer") {
        // Autopopulate doctor and bsnr based on LANR selection
        const selectedPayer: any = insurer[0].find(
          (option: any) => option.id === id || option.ik === value
        );
        // console.log("UZZHHHH", selectedPayer);
        if (selectedPayer) {
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            chipcard: selectedPayer?.ik,
            // tarifGroupId: selectedPayer?.tarifGroup?.id,
          }));
          setSelectedChipCard(selectedPayer.ik);
          // console.log("selectedPayer", selectedPayer.name);
        }
      }

      if (name === "rxtype") {
        // The Rezept-typ DECIDES the tarif group. Without this the group the Rx
        // was opened with survived the type change, so a type switched to
        // Privat here was still billed against the old group.
        const selectedRxTypeId = String(id ? id : inputValue);
        const { nextTarifGroupId, requiresChoice } = resolveTarifGroupForRxType(
          safeMasterTablesData,
          selectedRxTypeId,
          formValues?.tarifGroupId,
          accountTherapyType
        );
        setFormValues((prevValues) => ({
          ...prevValues,
          diagnosegroup: null, // Clear diagnosegroup when rxtype changes
          tarifGroupId: nextTarifGroupId,
        }));
        if (requiresChoice) {
          notificationStore.showMessage(
            "Bitte wählen Sie eine Tarifgruppe für den gewählten Rezept-Typ.",
            "warning"
          );
        }
        filterDiagnoseGroups(selectedRxTypeId);
      }

      // if (name === "chipcard") {
      //   const selectedPayer: any = insurer[0].find((option: any) => option.ik === value);
      //   console.log("UZZHHHH", selectedPayer);
      //   if (selectedPayer) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       Receiptpayer: selectedPayer.id,
      //       tarifGroupId: selectedPayer?.tarifGroup?.id,
      //     }));

      //     setSelectedPayer(selectedPayer.name);
      //     console.log("selectedPayer", selectedPayer.name);
      //   }
      // }
      // console.log("GTII", formValues);

      // else if (name === "doctor") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.contactInfo.firstNames===value

      //   );
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       lanr: selectedDoctor.number,
      //       bsnr: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      //   console.log('DOCTOR',selectedDoctor,formValues,value,doctorOptions)
      // }
    };

    const handleChipCardDataEntry = (event: React.KeyboardEvent | React.FocusEvent) => {
      rxvalidate();
      const chipCardValue = (event.currentTarget as HTMLInputElement).value;
      if (
        (event as React.KeyboardEvent).key === "Enter" ||
        event.type === "blur" ||
        event.type === "mouseleave"
      ) {
        // Check if the chipcard number is valid
        const selectedPayer = insurer[0]?.find((option: any) => option.ik === chipCardValue);
        if (selectedPayer) {
          // If valid, autofill payer info
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            Receiptpayer: selectedPayer?.id,
            // tarifGroupId: selectedPayer?.tarifGroup?.id,
          }));
          setSelectedPayer(selectedPayer.name);
          notificationStore.showMessage(
            `${selectedPayer?.id} ist ein IK für ${selectedPayer?.name}`,
            "success"
          );
        } else if (chipCardValue) {
          // Show error if chipcard is invalid
          notificationStore.showMessage(
            "Bitte geben Sie eine gültige Chipkartennummer ein.",
            "warning"
          );
          // Pass all form values with updated chipcard value for validation
        }
      }
    };
    useEffect(() => {
      rxvalidate();
    }, [formValues]);
    const handleAddInput = () => {
      setIcdCodeEntries([...icdCodeEntries, { userText: "" }]);

      // Update the formValues state as well to reflect the new entry
      setFormValues((prevValues: any) => ({
        ...prevValues,
        icdCodeEntries: [...prevValues.icdCodeEntries, { userText: "" }],
      }));
    };
//Could not find better way to implement this icdCode
    const handleICDCodeEntrySubmit = useCallback(
      async (icdEntry: any, index: number) => {
        if (!icdObject?.text) return;

        try {
          setFormValues((prevValues: any) => {
            const updatedICDCodeEntries = prevValues.icdCodeEntries.map((entry: any, i: number) =>
              i === index ? { id: icdEntry.id || "", userText: icdEntry.userText } : entry
            );

            // Avoid duplicating diagnosis text
            const existingICDTexts = prevValues.icdCodeEntries.map((e: any) => e.userText);
            const newDiagnosisText = existingICDTexts.includes(icdObject.text)
              ? prevValues.diagnosisText
              : prevValues.diagnosisText
              ? `${prevValues.diagnosisText} ${icdObject.text}`
              : icdObject.text;

            return {
              ...prevValues,
              icdCodeEntries: updatedICDCodeEntries,
              diagnosisText: newDiagnosisText.trim(),
            };
          });
        } catch (error) {
          console.error("Error updating ICD entry:", error);
        }
      },
      [icdObject]
    );

    useEffect(() => {
      if (icdObject) {
        // Use latest index and currentICD
        const index = icdCodeEntries.findIndex((e) => e.userText === currentICD);
        
        handleICDCodeEntrySubmit(icdCodeEntries[index], index);
      }
    }, [icdObject]);
    // const handleICDCodeEntrySubmit = async (icdCode: any, index: number) => {
    //   try {
    //     const icdObject: any = await getICD(icdCode.userText);
    //     console.log("OOPP", icdObject);
    //     if (icdObject) {
    //       // If the API call is successful and returns an icdObject, update the icdCodeEntries state with the normCode
    //       setFormValues((prevValues: any) => {
    //         const updatedICDCodeEntries = prevValues.icdCodeEntries.map(
    //           (icdEntry: any, i: number) => {
    //             return i === index
    //               ? { id: icdCode?.id || "", userText: icdCode.userText }
    //               : icdEntry;
    //           }
    //         );

    //         const concatenatedDiagnosisText = prevValues.diagnosisText
    //           ? `${prevValues.diagnosisText} ${icdObject.text}` // Append the new icdObject.text to the existing diagnosisText
    //           : icdObject.text;
    //         return {
    //           ...prevValues,
    //           icdCodeEntries: updatedICDCodeEntries,
    //           diagnosisText: concatenatedDiagnosisText.trim(), // Set diagnosisText to the concatenated value
    //         };
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error fetching ICD object:", error);
    //   }
    // };



    // console.log("UZRRFCFASG", icdCodeEntries);

    useEffect(() => {
      if (formValues.diagnosegroup) {
        const diagnoseGroupIsId = diagnoseGroups[0].some(
          (group: any) => group.id === formValues.diagnosegroup
        );
        // Find the matching diagnose group based on the selected code
        const selectedDiagnoseGroup = diagnoseGroupIsId
          ? diagnoseGroups[0].find((group: any) => group.id === formValues.diagnosegroup)
          : diagnoseGroups[0].find((group: any) => group.code === formValues.diagnosegroup);
        // console.log("formVa", formValues.diagnosegroup, selectedDiagnoseGroup, diagnoseGroups);

        if (selectedDiagnoseGroup) {
          // Generate symptoms based on selected checkboxes
          let selectedSymptoms = "";
          if (formValues.a) selectedSymptoms += selectedDiagnoseGroup.a + " ";
          if (formValues.b) selectedSymptoms += selectedDiagnoseGroup.b + " ";
          if (formValues.c) selectedSymptoms += selectedDiagnoseGroup.c + " ";
          if (formValues.d) selectedSymptoms += selectedDiagnoseGroup.d + " ";
          // console.log("SELECTE", selectedSymptoms, selectedDiagnoseGroup);
          setSelectedDiagnoseGroup(selectedDiagnoseGroup);
          setFormValues((prevValues: any) => ({
            ...prevValues,
            a: selectedDiagnoseGroup.a ? prevValues.a : false,
            b: selectedDiagnoseGroup.b ? prevValues.b : false,
            c: selectedDiagnoseGroup.c ? prevValues.c : false,
            d: selectedDiagnoseGroup.d ? prevValues.d : false,
            ...(prevValues.hasIndividualSymptoms ? {} : { symptoms: selectedSymptoms.trim() }),
          }));
        }
      }
    }, [formValues.diagnosegroup, formValues.a, formValues.b, formValues.c, formValues.d]);

    const warningDoctorSignatureConditions = () => {
      return (
        (formValues.status === "vorhanden" || formValues.status === "beim Therapeut") &&
        formValues.signatureStatus === ""
      );
    };

    const handleOpenDocumentViewer = () => {
      setIsDocumentViewerOpen(true);
    };

    const handleCloseDocumentViewer = () => {
      setIsDocumentViewerOpen(false);
    };

    const handleSubmit = async (event?: any) => {
      if (event) {
        setLoading(false);
        event.preventDefault(); // Prevent default form submission behavior
        // console.log("Event", event);
      }
      try {
        // Set loading to true to disable the form or show a loading indicator
        setLoading(true);
        if (warningDoctorSignatureConditions() && event) {
          // Show a warning/alert here
          setShowWarning(true);
        } else {
          // console.log("HJJUU", formValues, therapytableData.length, formValues.therapyRxs);
          //       const newColumnSet = [...treatmentColumns];
          //       const newRowAdded = Math.abs(formValues.therapies.length - therapytableData.length);
          // console.log('Newro',newRowAdded)
          //       for (let i = 0; i < newRowAdded; i++) {
          //         handleAddColumnSet(newColumnSet);
          //       }

          if (rxvalidate()) {
          // The doctor must actually be registered at the practice the Rx names:
          // the stamp takes its telephone number from the PRACTICE, so a
          // mismatched pair prints a stranger's number on a document that leaves
          // the building. Asked here rather than on a field, because the Arzt-Nr
          // check only fires when that field loses focus - correcting the BSNR
          // afterwards, or re-saving an Rx loaded from the database, slips past it.
          if (!(await confirmDoctorClinicMismatch(currentDoctor, currentClinic))) {
            return;
          }
            const updatedRxValues: any = {
              ...formValues,
              id: selectedRow?.id || "",
              rxNumber: selectedRow?.rxNumber || "",
              // date:
              //   patientValues.rxs.find((rx: any) => rx.id === selectedRow.id)
              //     ?.date || "",
              accountId:
                account[0].find((option: any) => option.name === formValues.accountId)?.id ||
                formValues.accountId,
              rxtype:
                rxType[0].find((option: any) => option.text === formValues.rxtype)?.id ||
                formValues.rxtype,
              diagnosegroup:
                diagnoseGroups[0].find((option: any) => option.code === formValues.diagnosegroup)
                  ?.id || formValues.diagnosegroup,
              Receiptpayer:
                insurer[0].find((option: any) => option.id === formValues.chipcard)?.id ||
                formValues.Receiptpayer,
              therapyRxs: (formValues.therapyRxs || [])
                .filter((obj: any) => obj.therapy !== "")
                // .map((therapy: any) => ({
                //   ...therapy,
                //   id: therapy.therapyId || therapy.id,
                //   frequency: therapy.frequency || "",
                // }))
                //  .filter(obj => obj.therapy !== "")

                .map((therapy: any) => {
                  if (!therapy.frequency || !therapy.therapy || !therapy.amount) {
                    throw new Error(
                      "Bitte fügen Sie die Behandlung hinzu, um das Rezept zu speichern/bearbeiten (Therapie, Menge, Häufigkeit sind Pflichtfelder) und deaktivieren Sie auch die Zelle nach der Bearbeitung!"
                    );
                  }
                  const validTherapy = validateTherapy(
                    therapy.rawText ?? therapy.therapy?.abbreviation ?? therapy.therapy,
                    safeMasterTablesData,
                    termOptions
                  );
                  const validFrequency = validateFrequency(
                    therapy.frequency.id || therapy.frequency,
                    safeMasterTablesData
                  );
                  if (!validTherapy || !validFrequency) {
                    throw new Error("Bitte geben Sie eine gültige Therapie und Häufigkeit ein.");
                  }
                  return {
                    ...therapy,
                    id: therapy.therapyId || therapy.id,
                    frequency: therapy.frequency,
                    unitsPerDay: therapy.unitsPerDay,
                    isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
                  };
                }),
            };

            if (currentDoctor) {
              updatedRxValues.doctorId = (currentDoctor as any).id || formValues.doctorId;
              updatedRxValues.LANR = (currentDoctor as any).LANR || formValues.doctorNumber || "";
            } else {
              updatedRxValues.doctor = null;
              updatedRxValues.doctorId = null;
              updatedRxValues.doctorNumber = "";
              updatedRxValues.LANR = "";
            }
            if (currentClinic) {
              updatedRxValues.clinicId = currentClinic.id || formValues.clinicId;
              updatedRxValues.BSNR = (currentClinic as any).BSNR || formValues.practiceNumber || "";
            } else {
              updatedRxValues.clinic = null;
              updatedRxValues.clinicId = null;
              updatedRxValues.practiceNumber = "";
              updatedRxValues.BSNR = "";
            }

            patientSaveRxs({ patientId: patientId!, rxs: [updatedRxValues] });

            setUnsavedChanges(false);

            setFormValues(updatedRxValues);

            notificationStore.showMessage("Rezept erfolgreich gespeichert", "success");
          } else {
            notificationStore.showMessage(
              "Bitte füllen Sie alle erforderlichen Felder aus",
              "warning"
            );
          }
        }
      } catch (error: any) {
        // console.log("Error adding rezept:", error);
        notificationStore.showMessage(
          error.message || "Fehler beim Speichern des Rezepts",
          "error",
          error
        );
      } finally {
        // Set loading back to false when the API call is complete
        setLoading(false);
        onCloseRx()
      }
    };
    const handleContinueWarning = () => {
      setShowWarning(false); // Close the warning dialog
      handleSubmit(); // Call handleSubmit directly
    };

    const handletherapyTableDataChange = (data: RowData[]) => {
      // console.log("datatttzz", data);

      // Rows pass through unchanged — doubling is `unitsPerDay` on the one
      // line (MD-232), never a second split row.
      const updatedData: any[] = data.map((item: any) => ({ ...item }));
      setFormValues((prevData: any) => {
        const newFormValues = {
          ...prevData,
          therapyRxs: updatedData,
        };
        // Compare new form values with previous ones
        if (
          JSON.stringify(prevData.therapyRxs) !== JSON.stringify(updatedData) &&
          prevData.therapyRxs.length > 0 &&
          updatedData.length > 0
        ) {
          setUnsavedChanges(true);
        }

        return newFormValues;
      });
      // console.log("jkkkkk", formValues);
      //   ...prevData,
      //   rxs: [
      //     {
      //       therapies: data,
      //     },
      //   ],
      // }));
    };

    // console.log("FORM", formValues.symptoms);
    let formattedDob: any; // Initialize formattedDob to an empty string

    if (formValues?.dob) {
      const parsedDate: any = new Date(formValues.dob);
      if (!isNaN(parsedDate)) {
        // Check if the parsed date is valid
        formattedDob = format(parsedDate, "dd.MM.yyyy");
      }
    }

    //   const handleSubmit = async (event: any) => {
    //     event.preventDefault(); // Prevent default form submission behavior

    //     try {
    //       console.log("VALUEEESS", values);
    //       if (validate()) {
    //         const updatedValues = {
    //           ...values,
    //           payer: isEditing
    //             ? insurer[0].find((option: any) => option.insurer === values.payer)
    //                 ?.id
    //             : values.payer,
    //         };
    //         await postPatients(updatedValues as unknown as PatientDto);
    //         if (isEditing) {
    //           await fetchAndFormatPatientData(filteredValue);
    //         } else {
    //           setValues(initialFValues as any);
    //           setrxTableData([]);
    //         }
    //         alert("Patient is added successfully");
    //       }
    //     } catch (error) {
    //       console.log("Error adding patient:", error);
    //     }
    //   };

    // const handleSubmit = (e: any) => {
    //   e.preventDefault();
    //   if (validate()) {
    //     // employeeService.insertEmployee(values)
    //     resetForm();
    //   }
    // };
    // console.log("SELECTEDROW", selectedRow);
    const handleCloseRx = () => {
      if (unsavedChanges) {
        // If there are unsaved changes, set a state to open the warning dialog
        setShowunsavedChangesWarning(true);
      } else {
        onCloseRx();
      }
    };

    const handleUnsavedChangesWarning = () => {
      if (showGenericView) {
        handleSubmit();
      } else {
        handleSubmit();
      }
    };

    const handleCloseUnsavedChangesWarning = () => {
      onCloseRx();
      // If user cancels and chooses not to continue, close the warning dialog
      setShowunsavedChangesWarning(false);
    };

    const [filteredDiagnoseGroups, setFilteredDiagnoseGroups] = useState([]);

    // Derive therapyType from the selected account (Physio vs. Ergo)
    const accountTherapyType = useMemo(() => {
      if (!formValues.accountId || !accounts) return "Physiotherapie";
      const selectedAccount = accounts.find(
        (a: any) => a.name === formValues.accountId || a.id === formValues.accountId
      );
      return selectedAccount?.therapyType || "Physiotherapie";
    }, [formValues.accountId, accounts]);

    // Only the groups the chosen Rezept-typ can be billed against — narrowed
    // further to the ones this practice's therapy type actually has line items
    // for, so the invariant cannot be broken by hand either.
    const tarifGroupOptions = useMemo(
      () =>
        resolveTarifGroupForRxType(
          safeMasterTablesData,
          formValues?.rxtype,
          formValues?.tarifGroupId,
          accountTherapyType
        ).options,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [safeMasterTablesData, formValues?.rxtype, formValues?.tarifGroupId, accountTherapyType]
    );

    const filterDiagnoseGroups = (rxtype: any) => {
      const filtered = diagnoseGroups[0].filter(
        (option: any) =>
          option.RxType?.id === rxtype &&
          (!option.therapyType || option.therapyType === accountTherapyType)
      );
      setFilteredDiagnoseGroups(filtered);
    };

    useEffect(() => {
      filterDiagnoseGroups(formValues.rxtype);
    }, [formValues.rxtype, accountTherapyType]);

    useEffect(() => {
      setCurrentDoctor(selectedRow?.doctor as any);
      setCurrentClinic(selectedRow?.clinic as any);
      if (selectedRow?.doctor || selectedRow?.clinic) {
        setFormValues((prev: any) => ({
          ...prev,
          doctorId: (selectedRow?.doctor as any)?.id || prev.doctorId,
          clinicId: (selectedRow?.clinic as any)?.id || prev.clinicId,
          doctorNumber: (selectedRow?.doctor as any)?.LANR || prev.doctorNumber,
          practiceNumber: (selectedRow?.clinic as any)?.BSNR || prev.practiceNumber,
        }));
      }
    }, [selectedRow?.doctor, selectedRow?.clinic]);

    useEffect(() => {
      if (creationResponse && creationResponse.doctorId && creationResponse.clinicId) {
        setCurrentDoctor({
          id: creationResponse.doctorId,
          contactInfo: creationResponse.contactInfo as any,
          clinics: creationResponse.clinics,
        });
        const matchedClinic = creationResponse.clinics.find((clinic: any) => clinic.id === creationResponse.clinicId);
        setCurrentClinic(matchedClinic);
        setFormValues((prev: any) => ({
          ...prev,
          doctorId: creationResponse.doctorId || "",
          clinicId: creationResponse.clinicId || "",
          doctorNumber: (creationResponse as any).LANR || prev.doctorNumber || "",
          practiceNumber: (matchedClinic as any)?.BSNR || prev.practiceNumber || "",
        }));
      }
    }, [creationResponse]);

    const handlePracticeNumberInteraction = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      if (isKeyboardEvent && isTriggerKey && value.length !== 0 && value.length !== 9) {
        e.preventDefault();
        notificationStore.showMessage("Mindestens 9 Zeichen erforderlich", "error");
        return;
      }

      if ((e.type === "blur" || isTriggerKey) && (value.length === 9 || value.length === 0)) {
        // setIsDoctorNumberDisabled(false);
        try {
          if (value.length === 9) {
            const clinicData = (await getClinicById(value)) as ClinicForModal;
            if (clinicData) {
              setDoesClinicExist(true);
              setCurrentClinic(clinicData);
              setFormValues((prev: any) => ({ ...prev, clinicId: clinicData.id }));
              setShowClinicData(true);
            } else {
              setDoesClinicExist(false);
              setCurrentClinicId(value);
              setCurrentDoctorId(currentDoctor?.id || "");
              setShowClinicData(false);
              setCurrentClinic(undefined);
              setIsClinicModalOpen(true);
            }
          } else if (value.length === 0) {
            setCurrentClinic(undefined);
          }
        } catch (error) {}
      }
    };

    const handleGetDoctorById = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      if (isKeyboardEvent && isTriggerKey && value.length !== 0 && value.length !== 9) {
        e.preventDefault();
        notificationStore.showMessage("LANR muss 9-stellig sein", "error");
        return;
      }

      if ((e.type === "blur" || isTriggerKey) && (value.length === 9 || value.length === 0)) {
        try {
          if (value.length === 9) {
            const doctorData: any = await getDoctorById(value);
            // console.log("doctor DATA -------> ", doctorData);
            if (doctorData) {
              setDoesDoctorExist(true);
              setCurrentDoctor(doctorData);
              setFormValues((prev: any) => ({ ...prev, doctorId: doctorData.id }));
              if (currentClinic && currentClinic.id) {
                const isDoctorInClinic = doctorData.clinics?.some(
                  (clinic: any) => clinic.id === currentClinic.id
                );

                if (isDoctorInClinic) {
                  notificationStore.showMessage(
                    "This doctor exists and is already associated with this clinic",
                    "success"
                  );
                } else {
                  const confirmed = await confirmDoctorClinicJoin(doctorData, currentClinic);
                  if (!confirmed) {
                    // User cancelled — clear the doctor selection (treat as a mistake).
                    setCurrentDoctor(undefined);
                    setDoesDoctorExist(false);
                    setSelectedLANR(null);
                    setFormValues((prev: any) => ({ ...prev, doctorId: "", doctorNumber: "" }));
                    return;
                  }
                  notificationStore.showMessage(
                    "This doctor exists already and will now get associated with this clinic",
                    "success"
                  );
                  handleAssociateDoctorToClinic(doctorData);
                }
              } else {
                notificationStore.showMessage(
                  "Bitte geben Sie zuerst eine gültige Betriebsstätten-Nr. (BSNR) ein.",
                  "warning"
                );
              }
            } else {
              setDoesDoctorExist(false);
              setIsClinicModalOpen(true);
              setCurrentDoctorId(value);
              setCurrentClinicId(currentClinic?.id || "");
            }
          } else if (value.length === 0) {
            setCurrentDoctor(undefined);
          }
        } catch (error) {}
      }
    };

    enum ReportMethod {
      Email = "Email",
      Fax = "Fax",
      Post = "Post",
    }

    const handleAssociateDoctorToClinic = async (doctorData: any) => {
      const createDoctorClinicDto = {
        id: doctorData?.id || "",
        contactInfo: {
          salutation: doctorData?.contactInfo?.salutation || "",
          firstNames: doctorData?.contactInfo?.firstNames || "",
          lastName: doctorData?.contactInfo?.lastName || "",
        },
        clinics: [
          {
            id: currentClinic?.id || "",
            contactInfo: {
              businessName: currentClinic?.contactInfo?.businessName || "",
              phone1: currentClinic?.contactInfo?.phone1 || "",
              fax: currentClinic?.contactInfo?.fax || "",
              addressLine1: currentClinic?.contactInfo?.addressLine1 || "",
              addressLine2: currentClinic?.contactInfo?.addressLine2 || "",
              city: currentClinic?.contactInfo?.city || "",
              zip: currentClinic?.contactInfo?.zip || "",
              email: currentClinic?.contactInfo?.email || "",
            },
            notes: currentClinic?.notes || "",
            methodForDrReport: (currentClinic?.methodForDrReport as ReportMethod) || "Email",
            methodForRxOrder: (currentClinic?.methodForRxOrder as ReportMethod) || "Email",
          },
        ],
      };

      // Call createDoctorWithClinic to save data
      //  setLoading(true);
      try {
        const response = await createDoctorWithClinic(createDoctorClinicDto);
        return response;
      } catch (error) {
        console.error("Error saving doctor and clinic:", error);
      } finally {
        setLoading(false);
      }
    };

    // useEffect(() => {
    //   const inputValue = selectedBSNR || formValues?.practiceNumber;
    //   const isEmpty = !inputValue || inputValue.trim() === "";

    //   if (isEmpty === false) {
    //     setIsDoctorNumberDisabled(false);
    //   }
    // }, [selectedBSNR, formValues?.practiceNumber, currentClinic?.id]);

    const FormContent = (
      <Form>
        <Grid
          container
          xs={12}
          spacing={4}
          direction="row"
          paddingTop={5}
          justifyContent="center"
          sx={{ border: "0px solid green" }}
        >
          {showGenericView && (
            <Grid
              container
              spacing={2}
              sx={{ marginLeft: 1, border: "0px solid blue", padding: "0" }}
            >
              <Grid item xs={12} md={8} sx={{ border: "0px solid yellow" }}>
                {/* <Verordnung13
                  rxFormData={
                    patientValues?.rxs?.filter(
                      (rx: any) => rx.rxNumber === selectedRow?.rxNumber
                    )[0]
                  }
                  patientValues={patientValues}
                  handleData={handleData}
                  masterTablesData={masterData}
                  readOnlyView={readOnlyView}
                  ref={childRef}
                  setUnsavedChanges={setUnsavedChanges}
                  newRx={false}
                  // ref={saveGenericViewData}
                /> */}
                <Verordnung13
                  selectedRxId={selectedRxId!}
                  patientId={patientId!}
                  openRx={openRx as boolean}
                  onCloseRx={onCloseRx}
                  // ref={saveGenericViewData}
                />
              </Grid>

              {!readOnlyView && (
                <Grid item xs={12} md={4} sx={{ border: "0px dotted black" }}>
                  <FlatCard title="Validierung">
                    <ValidationCard
                      patientData={patientValues}
                      selectedRx={
                        patientValues?.rxs?.filter(
                          (rx: any) => rx.rxNumber === selectedRow?.rxNumber
                        )[0]
                      }
                      form={formType.LONG}
                    />
                  </FlatCard>
                </Grid>
              )}
            </Grid>
          )}
          {!showGenericView && (
            <>
              <Grid
                item
                xs={12}
                md={5}
                container
                direction="column"
                spacing={2}
                sx={{ alignContent: "center" }}
              >
                <FlatCard title="Allgemeines">
                  <Controls.Select
                    name="rxtype"
                    label="Rezept-typ"
                    // id={1}
                    value={formValues?.rxtype}
                    onChange={handleInputChange}
                    options={rxType[0]?.map((option: any) => ({
                      label: option.text.toString(),
                      value: option.text.toString(),
                      id: option.id.toString(),
                    }))}
                    // required
                    error={rxerrors.rxtype}
                  />
                  <Controls.Select
                    name="accountId"
                    label="Mandant"
                    id={1}
                    value={formValues?.accountId}
                    onChange={handleInputChange}
                    options={accounts?.map((option: any) => ({
                      label: option.name.toString(),
                      value: option.name.toString(),
                      id: option.id.toString(),
                    }))}
                    required
                    error={rxerrors.accountId}
                    // error={errors.departmentId}
                  />
                  {/* <Box width="300px"> */}
                  <Typography align="left" variant="h6">
                    Optionen
                  </Typography>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Controls.Checkbox
                      name="isPerpetualApproved"
                      label="Langfristgenehmigung"
                      value={formValues?.isPerpetualApproved}
                      onChange={handleInputChange}
                    />
                    <Controls.Checkbox
                      name="isCopaymentExempted"
                      label="Zuzahlungsfrei"
                      value={formValues?.isCopaymentExempted}
                      onChange={handleInputChange}
                    />
                    <Controls.Checkbox
                      name="isAccident"
                      label="Unfallfolgen"
                      value={formValues?.isAccident}
                      onChange={handleInputChange}
                    />
                    <Controls.Checkbox
                      name="isBVG"
                      label="BVG"
                      value={formValues?.isBVG}
                      onChange={handleInputChange}
                    />
                    {/* <Button
                  onClick={() => {
                    const updatedIsPerpetual = !formValues.unvirtualize;

                    const event: any = {
                      target: {
                        name: "unvirtualize",
                        type: "checkbox",
                        checked: updatedIsPerpetual,
                      },
                    };

                    handleInputChange(event);
                  }}
                  sx={{ width: "200px" }}
                >
                  {formValues.unvirtualize
                    ? "Dauerrezept"
                    : "Dauerrezept anlegen"}
                </Button> */}
                  </div>
                  {/* </Box> */}

                  <Controls.Select
                    name="status"
                    label="Rezeptverbleib"
                    value={formValues?.status}
                    onChange={handleInputChange}
                    options={[
                      {
                        label: "noch nicht erstellt",
                        value: "noch nicht erstellt",
                      },
                      { label: "beim Patient", value: "beim Patient" },
                      { label: "beim Therapeut", value: "beim Therapeut" },
                      { label: "vorhanden", value: "vorhanden" },
                    ]}
                    // error={errors.departmentId}
                  />
                </FlatCard>
                <FlatCard title="Versicherung">
                  {/* <Controls.Select
                    name="Receiptpayer"
                    label="Kostenträger"
                    id={1}
                    value={selectedPayer || formValues.Receiptpayer}
                    onChange={handleInputChange}
                    options={insurer[0]?.map((option: any) => ({
                      label: option?.ik.toString(),
                      value: option?.name.toString(),
                      id: option.id.toString(),
                    }))}
                    // required
                    // error={rxerrors.Receiptpayer}
                  /> */}
                  <Controls.Input
                    disabled
                    name="Receiptpayer"
                    label="Kostenträger"
                    value={selectedPayer || formValues.Receiptpayer}
                    onChange={handleInputChange}
                  />
                  <Controls.Input
                    name="chipcard"
                    label="IK der Chipkarte"
                    value={selectedChipCard || formValues?.chipcard}
                    onChange={handleInputChange}
                    onKeyDown={handleChipCardDataEntry}
                    onBlur={handleChipCardDataEntry} // Add onBlur event
                    error={rxerrors.chipcard}
                  />
                  {/* <Controls.Select
                    name="chipcard"
                    label="IK der Chipkarte"
                    value={selectedChipCard || formValues?.chipcard}
                    onChange={handleInputChange}
                    // id={1}
                    options={insurer[0]?.map((insurer: any) => ({
                      label: insurer.name.toString(),
                      value: insurer.ik.toString(),
                      // id: insurer.id.toString(),
                    }))}
                    // required
                    // error={rxerrors.chipcard}
                    // error={errors.fullName}
                  /> */}
                  <Controls.Select
                    name="tarifGroupId"
                    label="Tarif Group"
                    value={formValues?.tarifGroupId}
                    onChange={handleInputChange}
                    options={tarifGroupOptions.map((value: any) => ({
                      label: value.toString(),
                      value: value.toString(),
                    }))}
                    required
                    error={rxerrors.tarifGroupId}
                  />
                  <Controls.Input
                    name="insureeNumber"
                    label="Versichertennummer"
                    value={formValues?.insureeNumber}
                    onChange={handleInputChange}
                    error={getKvnrError(formValues?.insureeNumber)}
                  />

                  <Controls.Select
                    name="insuranceStatus"
                    label="Status"
                    value={formValues?.insuranceStatus}
                    onChange={handleInputChange}
                    options={[
                      { label: "10000", value: "10000" },
                      { label: "30000", value: "30000" },
                      { label: "50000", value: "50000" },
                    ]}
                    // error={errors.departmentId}
                  />
                </FlatCard>
                {/* <FlatCard title="Arzt">
                  <Controls.Select
                    name="doctorNumber"
                    label="LANR"
                    value={selectedLANR || formValues?.doctorNumber}
                    onChange={handleInputChange}
                   options={doctorOptions?.map((doctor: any) => (
  // console.log("DOCTOR -------> ", doctor),
  // {
    // label: doctor?.id?.toString(),
    // value: doctor?.id?.toString(),
  // }
// ))}
                    // required
                    // error={rxerrors.doctorNumber}
                    // error={errors.fullName}
                  // />
                  // <Button
                    // onClick={() => handleOpenAddEditDialog(selectedLANR, selectedBSNR)}
                    // sx={{ padding: 0, width: "auto" }} // Adjust the width and other styles as needed
                  // >
                    // <AddIcon />
                    // Arzt hinzufügen / bearbeiten
                  // </Button>
                  // {isAddEditDialogOpen && (
                    // <DoctorDialog
                      // openAddEditDialog={isAddEditDialogOpen}
                      // handleCloseAddEditDialog={handleCloseAddEditDialog}
                      // doctorOptions={doctorOptions}
                      // selectedLANR={formValues.doctorNumber}
                      // selectedBSNR={formValues.practiceNumber}
                    // />
                  // )}
                  // <Controls.Select
                    // name="doctor"
                    // label="Arzt"
                    // id={1}
                    // value={selectedDoctor || formValues.doctorId}
                    // onChange={handleDoctorChange}
                    // options={doctorOptions?.map((doctor: any) => ({
                      // label: doctor.contactInfo.lastName.toString(),
                      // value: doctor.contactInfo.lastName.toString(),
                      // id: doctor.id.toString(),
                    // }))}
                    // required
                    // error={rxerrors.doctor}
                  // />
                  // <Controls.Input
                    // name="practiceNumber"
                    // label="BSNR"
                    // value={selectedBSNR || formValues?.practiceNumber}
                    // onChange={handleInputChange}
                    // required
                    // error={rxerrors.practiceNumber}
                  // />
                  // <Controls.RadioGroup
                    // label={
                      // <Typography align="left" variant="h6">
                        // Arztunterschrift vorhanden
                      // </Typography>
                    // }
                    // name="signatureStatus"
                    // value={formValues?.signatureStatus}
                    // options={[
                      // {
                        // id: "nicht kontrolliert",
                        // label: "nicht kontrolliert",
                      // },
                      // { id: "vorhanden", label: "vorhanden" },
                      // { id: "fehlend", label: "fehlend" },
                    // ]}
                    // onChange={handleInputChange}
                  // />
                // </FlatCard> */}
                {/* Legacy Arzt/Klinik and Datum section intentionally disabled. */}
              </Grid>

              <Grid item xs={12} md={5}>
                <Grid container direction="column" spacing={2} style={{ alignContent: "center" }}>
                  <FlatCard title="Diagnose">
                    {icdCodeEntries.map((icdEntry: any, index: any) => (
                      <div key={`icd-${index}`}>
                        <Controls.Input
                          label={`ICD ${index + 1}`}
                          name={`icdCodeEntries-${index}`}
                          value={icdEntry.userText}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // console.log("Eventssaa", e, index);
                            handleInputChange(e, index, icdEntry?.id);
                          }}
                          onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                            // console.log("KEY", e.key);
                            if (e.key === "Tab" || e.key === "Enter") {
                              e.preventDefault();
                              // handleICDCodeEntrySubmit(formValues.icdCodeEntries[index], index);
                              // handleICDCodeEntrySubmit(icdEntry, index);
                              setCurrentICD(icdEntry.userText);
                            }
                          }}
                          // error={errors.email}
                        />
                      </div>
                    ))}
                    <Button onClick={handleAddInput} style={{ padding: 0 }}>
                      <AddIcon />
                      <Typography color="white">ICD Hinzufügen</Typography>
                    </Button>

                    <Controls.TextArea
                      name="diagnosisText"
                      rows={4}
                      placeholder="Textdiagnose"
                      value={formValues?.diagnosisText}
                      onChange={handleInputChange}
                    />
                  </FlatCard>
                  <FlatCard title="Leitsymptomatik">
                    <Grid item xs={6}>
                      <Controls.Select
                        name="diagnosegroup"
                        label="Diagnosegruppe"
                        // id={1}
                        value={formValues?.diagnosegroup}
                        onChange={handleInputChange}
                        options={filteredDiagnoseGroups?.map((option: any) => ({
                          label: option.code.toString(),
                          value: option.code.toString(),
                          id: option.id.toString(),
                        }))}
                        // error={errors.departmentId}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Controls.Checkbox
                        name="a"
                        label="a"
                        value={formValues?.a}
                        onChange={handleInputChange}
                        disabled={!selectedDiagnoseGroup?.a}
                      />
                      <Controls.Checkbox
                        name="b"
                        label="b"
                        value={formValues?.b}
                        onChange={handleInputChange}
                        disabled={!selectedDiagnoseGroup?.b}
                      />
                      <Controls.Checkbox
                        name="c"
                        label="c"
                        value={formValues?.c}
                        onChange={handleInputChange}
                        disabled={!selectedDiagnoseGroup?.c}
                      />
                      <Controls.Checkbox
                        name="d"
                        label="d"
                        value={formValues?.d}
                        onChange={handleInputChange}
                        disabled={!selectedDiagnoseGroup?.d}
                      />
                    </Grid>

                    <Controls.Checkbox
                      name="hasIndividualSymptoms"
                      label="Patientenindividuelle Leitsymptomatik"
                      value={formValues?.hasIndividualSymptoms}
                      onChange={handleInputChange}
                    />

                    <Controls.TextArea
                      name="symptoms"
                      rows={4}
                      placeholder="Patientenindividuelle Leitsymptomatik als
              Freitext angeben"
                      value={formValues?.symptoms}
                      onChange={handleInputChange}
                    />
                  </FlatCard>
                  <FlatCard title="Behandlungen">
                    <EditTable
                      initialColumns={treatmentColumns}
                      initialRows={therapytableData}
                      onTableDataChange={handletherapyTableDataChange}
                      isSingleRxPage={true}
                      masterTablesData={safeMasterTablesData}
                      selectedRx={{ ...formValues, therapyType: accountTherapyType }}
                      // parseInput={parseInput}
                    />
                  </FlatCard>
                  <FlatCard title="Anforderungen">
                    <Box display="flex" alignItems="center">
                      <Typography variant="body1" sx={{ marginRight: "8px" }}>
                        Hausbesuch
                      </Typography>
                      <FormControlLabel
                        label=""
                        control={
                          <>
                            <Checkbox
                              checked={formValues.isHomeVisit === true}
                              onChange={handleCheckboxChange}
                              name="visitTypeCheckboxJa"
                              value="yes"
                            />
                            <Typography variant="body1">ja</Typography>
                            <Checkbox
                              checked={formValues.isHomeVisit === false}
                              onChange={handleCheckboxChange}
                              name="visitTypeCheckboxNein"
                              value="no"
                            />
                            <Typography variant="body1">nein</Typography>
                          </>
                        }
                      />
                    </Box>

                    <Controls.Checkbox
                      name="problematic"
                      label="auf Kontrolle"
                      value={formValues?.problematic}
                      onChange={handleInputChange}
                    />
                    <Controls.Checkbox
                      name="changeRequested"
                      label="auf zum Ändern"
                      value={formValues?.changeRequested}
                      onChange={handleInputChange}
                    />
                    {/* <Controls.Checkbox
              name="booked"
              label="abgerechnet"
              value={formValues?.booked}
              onChange={handleInputChange}
            /> */}

                    <Controls.Checkbox
                      name="therapyReport"
                      label="Therapiebericht"
                      value={formValues?.therapyReport}
                      onChange={handleInputChange}
                    />
                    {/* <Controls.Checkbox
                name="homeVisit"
                label="Haus-/Heimbesuch"
                value={formValues?.homeVisit}
                onChange={handleInputChange}
              /> */}
                    {/* <Controls.Checkbox
                name="isHomeVisitFree"
                label="Heimbesuch zuzahlungsfrei"
                value={formValues?.isHomeVisitFree}
                onChange={handleInputChange}
              /> */}
                    <Controls.Checkbox
                      name="urgent"
                      label="Dringlicher Behandlungsbedarf"
                      value={formValues?.urgent}
                      onChange={handleInputChange}
                    />
                    {/* <Controls.Checkbox
                name="isAutoAddReport"
                label="Berichtsposition automatisch hinzufügen"
                value={formValues?.isAutoAddReport}
                onChange={handleInputChange}
              /> */}
                    <Controls.Checkbox
                      name="hygiene"
                      label="Hygieneposition automatisch hinzufügen"
                      value={formValues?.hygiene}
                      onChange={handleInputChange}
                    />
                    {/* </Box> */}
                    <Typography color="red" align="left">
                      ggf. Therapieziele/weitere med. Befunde und hinweise
                    </Typography>
                    <Controls.TextArea
                      name="additionalNotes"
                      rows={4}
                      placeholder=""
                      value={formValues?.additionalNotes}
                      onChange={handleInputChange}
                    />
                  </FlatCard>
                  {/* <FlatCard title="Notizen">
                  <Notes notes={rxNotes} setNotes={updateNote} maxVisibleNotes={rxNotes.length} />
                </FlatCard> */}
                </Grid>
                {!useDialog && (
                  <Box
                    sx={{
                      border: "10px",
                      display: "flex",
                      gap: "8px",
                      padding: "40px",
                    }}
                  >
                    {/* <Controls.Button type="submit" >Submit</Controls.Button>              
        <Controls.Button onClick={resetForm}>Reset</Controls.Button> */}
                    <Button type="submit" disabled={loading}>
                      Speichern
                    </Button>
                    {/* <Button
          // onClick={resetForm}
          >
            Reset
          </Button> */}
                  </Box>
                )}
              </Grid>
            </>
          )}
        </Grid>
        <Modal
          open={loading}
          aria-labelledby="loading-modal-title"
          aria-describedby="loading-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <CircularProgress size={60} />
          </div>
        </Modal>
        {unsavedChangesWarning && (
          <WarningDialog
            open={true} // Ensure the warning dialog is open
            onClose={handleCloseUnsavedChangesWarning} // Function to close the dialog
            onContinue={handleUnsavedChangesWarning} // Function to continue despite unsaved changes
            title="Änderungen speichern?"
            content="Du hast einige Änderungen gemacht. Möchtest du diese speichern, bevor du schließt?"
            isConfirmSave
          />
        )}
      </Form>
    );

    // if (!selectedRxId) {
    //   return (
    //     <Box p={2}>
    //       <span>Kein Rezept ausgewählt</span>
    //     </Box>
    //   );
    // }

    if (isRxLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (rxError) {
      return (
        <Box p={2}>
          <span>Fehler beim Laden des Rezepts für {selectedRxId}</span>
        </Box>
      );
    }
    return useDialog && openRx ? (
      <Dialog open={openRx} onClose={handleCloseRx} maxWidth="xl" fullWidth>
        <DialogTitle>
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            <>Rezept bearbeiten</>
            <Box display={"flex"} alignItems={"center"}>
              <Switch
                checked={showGenericView}
                onChange={handleToggle}
                inputProps={{ "aria-label": "toggle generic/form view" }}
              />
              <Typography>{showGenericView ? "Musteransicht" : "Allgemeine Ansicht"}</Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>{FormContent}</DialogContent>
        <DialogActions>
          <>
            <Button variant="text" onClick={handleCloseRx}>
              Abbrechen
            </Button>
            <Button
              variant="outlined"
              onClick={handleOpenDocumentViewer}
              sx={{
                backgroundColor: "#f5f5f5",
                color: "#1976d2",
                "&:hover": { backgroundColor: "#e0e0e0" },
              }}
            >
              📄 Document Viewer
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={loading || Object.values(rxerrors).some((error) => error !== "")}
              variant="contained"
            >
              Speichern
            </Button>
          </>
        </DialogActions>
        <VerordnungDialog
          openAddEditDialog={isClinicModalOpen}
          handleCloseAddEditDialog={() => setIsClinicModalOpen(false)}
          clinicId={currentClinicId}
          setCreationResponse={setCreationResponse}
          doctorId={currentDoctorId}
          currentClinic={currentClinic}
          // isDoctorNumberDisabled={isDoctorNumberDisabled}
        />
        {isDocumentViewerOpen && (
          <SimpleDocumentViewer
            open={isDocumentViewerOpen}
            onClose={handleCloseDocumentViewer}
            patientId={patientValues?.id || undefined}
          />
        )}
      </Dialog>
    ) : (
      FormContent
    );
  }
);
export default RxPage;
